import React from 'react'
import PropTypes from 'prop-types'
import Item from './item'


export default class ItemList extends React.Component {
    render() {
        const {isShowCheckbox, items = [], checkIds, onTodoClick, onDelete, onChangePermission,currActive,isHasPermission} = this.props;
        const roleContainerStyles = {
            listStyle: 'none',
            padding: 0,
            display: 'flex',
            // justifyContent: 'space-between',
            flexDirection: 'column',
            textAlign: 'center',
            height: '100%',
            width: '100%',
            overflowY:'auto'
        }
        return (
            <ul style={roleContainerStyles}>
                {items.map((item,index) => {
                    return (
                        <Item 
                            key={item.id}
                            item={item}
                            isShowCheckbox={isShowCheckbox}
                            checkIds={checkIds}
                            onTodoClick={onTodoClick}
                            onDelete={onDelete}
                            onChangePermission={onChangePermission}
                            currActive={currActive}
                            isHasPermission={isHasPermission}
                        />
                    )
                })}
            </ul>
        )
    }
} 

ItemList.propsTypes = {
    onTodoClick: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired
    }).isRequired).isRequired
}


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/components/itemList.js